import { useNavigate } from 'react-router-dom';
import { Coins } from 'lucide-react';
import { useCredits } from '@/contexts/CreditsContext';

/**
 * Header chip showing the user's current credit balance. Clicking navigates
 * to /billing. Unlimited / admin accounts get an infinity glyph instead.
 */
export default function CreditsChip() {
  const navigate = useNavigate();
  const { balance, isUnlimited } = useCredits();

  // Credits system is gated behind force_credit_charging. Unlimited users
  // (the default for everyone except opted-in QA accounts) see NO chip at
  // all — no "∞ Unlimited", no "· cr", no hint that credits exist.
  if (isUnlimited) return null;

  if (balance === null) return null;

  const low = balance < 20;
  const medium = balance < 100 && !low;
  const tone = low
    ? 'bg-red-50 text-red-700 border-red-200 hover:bg-red-100'
    : medium
    ? 'bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100'
    : 'bg-slate-50 text-slate-700 border-slate-200 hover:bg-slate-100';

  return (
    <button
      onClick={() => navigate('/billing')}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs sm:text-sm font-semibold transition-colors ${tone}`}
      data-testid="credits-chip"
      title={`${balance.toLocaleString()} credits remaining — click to top up`}
    >
      <Coins className="h-3.5 w-3.5" />
      {balance.toLocaleString()} cr
    </button>
  );
}
